var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPartnerThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#CCDDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4823 21.1106C27.4806 21.1151 27.4839 21.1198 27.4887 21.1198C27.4938 21.1198 27.4971 21.1253 27.4947 21.1299C27.4722 21.1722 27.4495 21.2146 27.4266 21.2569C27.0222 22.2891 26.4191 23.2175 25.6657 23.9922C23.6359 26.7519 21.1985 29.1208 20.3284 29.9367C20.1422 30.1113 19.8578 30.1113 19.6716 29.9367C18.8015 29.1208 16.3641 26.7519 14.3343 23.9922C13.581 23.2175 12.9778 22.2891 12.5734 21.2569C12.5505 21.2146 12.5278 21.1722 12.5053 21.1299C12.5029 21.1253 12.5062 21.1198 12.5113 21.1198C12.5161 21.1198 12.5194 21.1151 12.5177 21.1106C12.1832 20.2066 12 19.2261 12 18.2018C12 13.6721 15.5817 10 20 10C24.4183 10 28 13.6721 28 18.2018C28 19.2261 27.8168 20.2066 27.4823 21.1106ZM20 21C21.6569 21 23 19.6569 23 18C23 16.3431 21.6569 15 20 15C18.3431 15 17 16.3431 17 18C17 19.6569 18.3431 21 20 21Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPartnerThumbnail);
export default __webpack_public_path__ + "static/media/default_partner_thumbnail.64f3cf874de1df0250ea080d847b1322.svg";
export { ForwardRef as ReactComponent };